import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const bagsApi = createApi({
  reducerPath: 'bags',
  baseQuery: createBaseQueryWithReauth('/bags'),

  tagTypes: ['Bags'],

  endpoints: builder => ({
    getBags: builder.query({
      query: () => ({
        url: `/my`,
        method: 'GET',
      }),
      providesTags: ['Bags'],
    }),

    getArchiveBags: builder.query({
      query: ({ keyword = '', datetime_from = '', datetime_to = '', status= [], shop_ids = [] } = {}) => {
        const params = new URLSearchParams({
          keyword,
          datetime_from,
          datetime_to,
          
        });

        shop_ids.forEach(id => params.append('shop_ids[]', id));
        status.forEach(id => params.append('status[]', id));
        return {
        url: `/archive`,
          method: 'GET',
          params,
        }
      },
      providesTags: ['Bags'],
    }),


    getBag: builder.query({
      query: (id) => ({
        url: `/view?id=${id}`,
        method: 'GET',
      }),
      providesTags: ['Bags'],
    }),

    createBag: builder.mutation({
      query: data => ({
        url: '/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Bags'],
    }),

    calculateBag: builder.mutation({
      query: data => ({
        url: '/calculate-start',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Bags'],
    }),


    editBag: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/update?id=${id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Bags'],
    }),

    editBagCount: builder.mutation({
      query: ({ id, count }) => ({
        url: `/update-count?id=${id}&count=${count}`,
        method: 'POST',
      }),
      invalidatesTags: ['Bags'],
    }),
    editBagShop: builder.mutation({
      query: ({ id, shop_id }) => ({
        url: `/update-shop?id=${id}&shop_id=${shop_id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Bags'],
    }),
    editBagDates: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/update-dates?id=${id}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Bags'],
    }),
    publishBag: builder.mutation({
      query: (id) => ({
        url: `/publish?id=${id}`,
        method: 'POST',

      }),
      invalidatesTags: ['Bags'],
    }),

    deleteBag: builder.mutation({
      query: id => ({
        url: `/delete?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Bags'],
    }),
    deleteAllBag: builder.mutation({
      query: id => ({
        url: `/delete-all?id=${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Bags'],
    }),
  }),
});

export const {
  useGetBagsQuery,
  useGetBagQuery,
  useGetArchiveBagsQuery,
  useCreateBagMutation,
  useCalculateBagMutation,
  useEditBagMutation,
  useEditBagCountMutation,
  useEditBagDatesMutation,
  usePublishBagMutation,
  useBagMutation,
  useEditBagShopMutation,
  useDeleteBagMutation,
  useDeleteAllBagMutation
} = bagsApi;
